import React from 'react';
import { Monitor, Camera, Printer, FileText, Folder, BarChart3 } from 'lucide-react';

export const initialCategories = [
  { id: 'ap12', name: 'Настройка АР12', icon: <Monitor className="w-5 h-5" /> },
  { id: 'scanners', name: 'Сканеры', icon: <Camera className="w-5 h-5" /> },
  { id: 'printers', name: 'Принтеры', icon: <Printer className="w-5 h-5" /> },
  { id: 'applicators', name: 'Аппликаторы', icon: <FileText className="w-5 h-5" /> },
  { id: 'cameras', name: 'Камеры', icon: <Camera className="w-5 h-5" /> },
  { id: 'xtrek', name: 'xTrek', icon: <Folder className="w-5 h-5" /> },
  { id: 'templates', name: 'Шаблоны для принтеров', icon: <FileText className="w-5 h-5" /> },
  { id: 'reports', name: 'Отчеты', icon: <BarChart3 className="w-5 h-5" /> }
];

export const initialManuals = {
  ap12: [
    {
      id: 'ap12-1',
      title: 'Базовая настройка',
      content: '',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }
  ],
  reports: [
    {
      id: 'timesheet',
      title: 'TimeSheet',
      content: '<h2>Система учета рабочего времени</h2><p>Здесь вы можете внести данные о количестве дней, затраченных на проекты.</p>',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: 'overtime',
      title: 'Переработки',
      content: '<h2>Учет переработок и работы в выходные дни</h2><p>Здесь вы можете внести данные о переработках.</p>',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }
  ],
  scanners: [],
  printers: [],
  applicators: [],
  cameras: [],
  xtrek: [],
  templates: []
};